import Logo from "../Logo";
import { ContactManager } from "../ContactManager";

export const Footer = ({ t }) => (
  <footer
    data-testid="site-footer"
    style={{ background: "var(--bg-inverse)" }}
    className="pt-20 pb-10"
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <div
        className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12"
        style={{ borderBottom: "1px solid var(--border-on-dark)" }}
      >
        <div className="md:col-span-5">
          <div className="mb-6">
            <Logo variant="light" height={80} />
          </div>
          <p
            className="text-sm max-w-sm leading-relaxed"
            style={{ color: "rgba(255,255,255,0.75)" }}
          >
            {t.footer.tagline}
          </p>
          <p
            className="mt-4 text-sm"
            style={{ color: "var(--gold-300)" }}
          >
            {t.footer.domain}
          </p>
        </div>
        <div className="md:col-span-3">
          <div
            className="eyebrow mb-5"
            style={{ color: "rgba(255,255,255,0.55)" }}
          >
            {t.footer.navLabel}
          </div>
          <ul className="space-y-3">
            {t.footer.nav.map((n, i) => {
              const hrefs = ["#about", "#services", "#cases", "#contact"];
              return (
                <li key={n}>
                  <a
                    href={hrefs[i]}
                    className="under-link text-sm"
                    style={{ color: "rgba(255,255,255,0.85)" }}
                  >
                    {n}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="md:col-span-4">
          <div
            className="eyebrow mb-5"
            style={{ color: "rgba(255,255,255,0.55)" }}
          >
            {t.footer.contactLabel}
          </div>
          <a
            href={`mailto:${t.footer.contact}`}
            data-testid="footer-email"
            className="under-link font-serif text-lg"
            style={{ color: "var(--white)" }}
          >
            {t.footer.contact}
          </a>
          <div className="mt-6">
            <ContactManager
              size="footer"
              theme="dark"
              labels={t.contactManager}
            />
          </div>
        </div>
      </div>
      <div className="pt-8 flex flex-col md:flex-row gap-4 justify-between items-start md:items-center">
        <p
          className="text-xs max-w-3xl leading-relaxed"
          style={{ color: "rgba(255,255,255,0.55)" }}
        >
          {t.footer.legal}
        </p>
      </div>
    </div>
  </footer>
);
